import { useState } from "react";
import { X } from "lucide-react";

// Bumped per release so visitors who dismissed the previous announcement
// still see the new one.
export const ANNOUNCEMENT_KEY = "announcement:2026-05";

export default function AnnouncementBar({ onDismiss }) {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(ANNOUNCEMENT_KEY) === "true"
  );

  if (dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(ANNOUNCEMENT_KEY, "true");
    setDismissed(true);
    onDismiss?.();
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-[#d7e3f8] border-b border-blue-200 text-[#0f1b3d] text-sm py-2 px-4 flex justify-center items-center shadow-sm">

      {/* Desktop Version */}
      <div className="hidden md:flex items-center space-x-3">
        <span className="bg-[#0f1b3d] text-white text-[10px] px-2 py-0.5 rounded-full font-bold uppercase tracking-widest">
          May 2026
        </span>
        <span className="font-semibold tracking-tight">
          Managed Takedowns + deeper data access — what's new this release.
        </span>
        <a
          href="https://whiteintel.io/blog/may-2026-release-notes.html"
          className="ml-2 text-red-600 font-bold hover:text-red-700 underline underline-offset-4 decoration-2 transition-all flex items-center"
        >
          Read the release notes <span className="ml-1">→</span>
        </a>
      </div>

      {/* Mobile Version */}
      <div className="flex md:hidden items-center justify-between w-full max-w-sm text-xs sm:text-sm pr-8">
        <span className="font-bold truncate mr-2">
          May 2026 release · Managed Takedowns
        </span>
        <a
          href="https://whiteintel.io/blog/may-2026-release-notes.html"
          className="text-red-600 font-extrabold whitespace-nowrap"
        >
          Read more →
        </a>
      </div>

      {/* Dismiss Button */}
      <button
        onClick={handleDismiss}
        className="absolute right-4 top-1/2 -translate-y-1/2 text-[#0f1b3d]/50 hover:text-[#0f1b3d] transition-colors"
        aria-label="Dismiss announcement"
      >
        <X size={15} />
      </button>
    </div>
  );
}
